import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { About, Contact, Home, Products } from "./pages";
import { Navbar } from "./components/general/NavBar";
import { Footer } from "./components/general/Footer";
import { BackToTop } from "./components/general/BackToTop";
import { PageFade } from "./components/general/Page";
import { LanguageProvider } from "./contexts/LanguageContext";
import { usePageTransition } from "./hooks";
import { GlobalStyle } from "./theme";

const AppRoutes = () => {
  const { displayLocation, isLeaving } = usePageTransition();

  return (
    <PageFade key={displayLocation.pathname} $leaving={isLeaving}>
      <Routes location={displayLocation}>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </PageFade>
  );
};

function App() {
  return (
    <LanguageProvider>
      <GlobalStyle />
      <Router>
        <Navbar />
        <AppRoutes />
        <BackToTop />
      </Router>
    </LanguageProvider>
  );
}

export default App;
